export default class SidePanel {
    constructor(cameraControls, renderer, camera, time, scene) {
        this.cameraControls = cameraControls;
        this.renderer = renderer;
        this.camera = camera;
        this.time = time;
        this.scene = scene;

        // Animating the renderer/camera to keep object in center
        // this.transitionDuration = 600; // 600ms transition duration
        this.transitionStartTime = null;
        this.transitioning = false;
        this.originalAspect = this.camera.aspect;
        this.originalWidth = document.querySelector('.webgl').clientWidth;
        this.originalHeight = document.querySelector('.webgl').clientHeight;
        this.targetAspect = null;
        this.targetWidth = null;
        this.targetHeight = null;

        this.allPoints = document.querySelectorAll('[class^="point-"]')

        this.setupEventListeners();
        this.tabIndex();

        // this.cameraControls.addEventListener('transitionstart', () => {
        //     console.log('Started' + this.time.elapsed)
        // })

        // this.cameraControls.addEventListener('transitionend', () => {
        //     console.log('Ended' + this.time.elapsed)
        // });

    }

    setupEventListeners() {
        const closes = document.querySelectorAll('.close');
        for (const close of closes) {
            const sidePanel = close.parentElement
            close.addEventListener('click', () => {
                this.closePanel(close, sidePanel);
            });

            // Event listener for keydown event (Escape or Spacebar)
            close.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' || event.key === ' ') {
                    event.preventDefault();  // Prevent any default action for Spacebar
                    const sidePanel = close.parentElement
                    this.closePanel(close, sidePanel);
                }
            });
        }

        const menuItems = document.querySelectorAll('.location');
        for (const menuItem of menuItems) {
            menuItem.addEventListener('click', () => {
                this.closePanels();
            });
        }

        // Add event listener for the Escape key to close side-panels
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                this.handleEscapeKey();
            }
        })
    }

    tabIndex() {
        // Make points tabbable when visible
        this.allPoints.forEach(el => {
            el.querySelector('.label').setAttribute('tabindex', '0');
        })

        // Make content tabbable only when visible
        const sidePanel = document.querySelectorAll('.side-panel')

        sidePanel.forEach(el => {
            const focusableElements = el.querySelectorAll('.close, a, button, input, textarea, select, audio, video, form, [tabindex]:not([tabindex="-1"])');
            focusableElements.forEach(el => {
                el.setAttribute('tabindex', '-1');
            });
        });
    };


    handleEscapeKey() {
        // Find the currently visible side-panel
        const visiblePanel = document.querySelector('.side-panel.visible');
        if (visiblePanel) {
            const closeBtn = visiblePanel.querySelector('.close');
            if (closeBtn) {
                this.closePanel(closeBtn, visiblePanel);
            }
        }
    }

    startTransition(toWidth, toHeight, sidePanelWidth) {
        // this.transitionStartTime = this.time.elapsed;
        // this.originalAspect = this.camera.aspect;
        // this.originalWidth = document.querySelector('.webgl').clientWidth;
        // this.originalHeight = document.querySelector('.webgl').clientHeight;
        // this.targetAspect = toWidth / toHeight;
        // this.targetWidth = toWidth;
        // this.targetHeight = toHeight;
        // this.transitioning = true;


        // This was causing performance issues due to repaint/recomposite and recalculate layout every frame while doing this
        // document.querySelector('.points').style.left = '-282px'
        // document.querySelector('.webgl').style.left = '-282px'

        // Solution that doesn't repaint/layout: transform. Messes up the animation I feel?
        // document.querySelector('.point > .visible').style.transform = 'translateX(-282px)';

        if (!globalThis.mobile) {
            document.querySelector('.webgl').style.transform = 'translateX(-282px)';
        }



        // console.log(document.querySelector('.webgl').style.left)
        // this.renderer.instance.setSize(this.originalWidth - 564, this.originalHeight);
        // this.camera.aspect = (this.originalWidth - 564) / (this.originalHeight);
        // this.camera.updateProjectionMatrix();

        // document.querySelector('.webgl').style.width -= '564px'
        // console.log(document.querySelector('.webgl').style.width)
        // this.cameraControls.transitionDuration = transitionDuration;

        // this.canvas = null;

        // console.log(this.cameraControls.getRemainingTransitionTime())

        // console.log(this.cameraControls.transitionDuration)



        // const animate = () => {
        //     if (this.transitioning) {
        //         const elapsedTime = this.time.elapsed - this.transitionStartTime;
        //         const t = Math.min(elapsedTime / this.transitionDuration, 1); // Normalize time to [0, 1]

        //         // Interpolate aspect ratio and renderer size
        //         const currentAspect = this.originalAspect + t * (this.targetAspect - this.originalAspect);
        //         const currentWidth = this.originalWidth + t * (this.targetWidth - this.originalWidth);
        //         const currentHeight = this.originalHeight + t * (this.targetHeight - this.originalHeight);

        //         // Apply interpolated values
        //         this.camera.aspect = currentAspect;
        //         this.camera.updateProjectionMatrix();
        //         this.renderer.instance.setSize(currentWidth, currentHeight);

        //         // Render the scene
        //         this.renderer.instance.render(this.scene, this.camera);

        //         if (t < 1) {
        //             requestAnimationFrame(animate);
        //         } else {
        //             this.transitioning = false;
        //         }
        //     }
        // };

        // requestAnimationFrame(animate);
    }

    showContent(point) {
        document.querySelector('.side-panel').classList.remove('visible');
        document.querySelector('.menu').classList.add('hide')

        const sidePanel = point.parentElement.querySelector('.side-panel')

        sidePanel.classList.add('visible');

        // Add lazy-loading, load the image on showcontent
        const images = sidePanel.querySelectorAll('img')
        images.forEach(img => {
            if (img.src) return;
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            if (img.decode) img.decode().catch(() => { });
        })

        this.allPoints.forEach(point => {
            point.classList.add('removed')
            point.classList.remove('shown')
        })
        // console.log(point.classList.contains("visible"))

        // Calculate the offset needed to center the object in the visible canvas
        // Handle renderer and camera
        const canvasWidth = document.querySelector('.webgl').clientWidth;
        const canvasHeight = document.querySelector('.webgl').clientHeight;

        let sidePanelWidth = null
        // Video is full screen so need to go fullscreen
        if (point.parentElement.classList.contains('video')) {
            sidePanelWidth = canvasWidth
        }
        else {
            sidePanelWidth = 564
        }

        const newWidth = canvasWidth - sidePanelWidth;

        // Start the transition
        this.startTransition(newWidth, canvasHeight, sidePanelWidth);

        // Calculate the world space offset for the camera's position
        const panelPercentage = sidePanelWidth / canvasWidth;
        const distanceToTarget = this.camera.position.distanceTo(this.cameraControls._target);
        const offsetX = panelPercentage * distanceToTarget * Math.tan(THREE.MathUtils.degToRad(this.camera.fov / 2)) * this.camera.aspect;

        // Make content tabbable only when visible
        const focusableElements = sidePanel.querySelectorAll('a, button, input, textarea, select, audio, video, form, [tabindex]:not([tabindex="-1"])');
        const close = sidePanel.querySelector('.close')
        focusableElements.forEach(el => {
            el.removeAttribute('tabindex');
        });
        close.setAttribute('tabindex', '0')

        // TODO: Move the teleports code here?
        document.dispatchEvent(new CustomEvent("sidePanelOpen", {
            detail: {
                open: true,
                event: event,
            }
        }));
    }

    closePanel(close, sidePanel) {
        // Go back to the previous camera state
        this.cameraControls.reset(true);
        close.closest('.side-panel').classList.remove('visible');
        document.querySelector('.menu').classList.remove('hide')

        // Restore the original canvas size with a transition
        this.startTransition(window.innerWidth, window.innerHeight);
        // document.querySelector('.point > .visible').style.transform = 'translateX(-282px)';

        // This moves the canvas back to the right: 0
        document.querySelector('.webgl').style.transform = 'translateX(0px)';

        // Make content tabbable only when visible
        const focusableElements = sidePanel.querySelectorAll('a, .close, button, input, textarea, select, audio, video, form, [tabindex]:not([tabindex="-1"])');
        focusableElements.forEach(el => {
            el.setAttribute('tabindex', '-1');
        });

        // Wait until animation is done
        setTimeout(() => {
            this.allPoints.forEach(point => {
                point.classList.remove('removed')
                point.classList.add('shown')
            })
        }, 500)

        // TODO: Move the teleports code here?
        document.dispatchEvent(new CustomEvent("sidePanelOpen", {
            detail: {
                open: false,
                event: event,
            }
        }));
    }

    closePanels() {
        // Go back to the previous camera state
        // this.cameraControls.reset(true);
        const sidePanels = document.querySelectorAll('.side-panel')
        for (const sidePanel of sidePanels) {
            sidePanel.classList.remove('visible');
        }
        // Restore the original canvas size with a transition
        this.startTransition(window.innerWidth, window.innerHeight);
        // document.querySelector('.point > .visible').style.transform = 'translateX(-282px)';
        document.querySelector('.webgl').style.transform = 'translateX(0px)';

        // TODO: Move the teleports code here?

    }

    // For videos
    // playFullscreen(point) {
    //     console.log(point.querySelectorAll('.content'))
    //     const container = point.querySelectorAll('.content')[0];
    //     const iframe = point.querySelectorAll('iframe')[0];
    //     const player = iframe.querySelectorAll('video')[0]
    //     // const videoUrl = iframe.src

    //     console.log(iframe)

    //     // Update iframe src to include autoplay
    //     // iframe.src = "https://www.youtube.com/embed/xxx?autoplay=1&mute=1"; // 'mute=1' required for autoplay without user gesture

    //     container.style.display = "block"; // make it visible

    //     // Try to request fullscreen
    //     if (iframe.requestFullscreen) {
    //         iframe.requestFullscreen();
    //     } else if (iframe.mozRequestFullScreen) {
    //         iframe.mozRequestFullScreen();
    //     } else if (iframe.webkitRequestFullscreen) {
    //         iframe.webkitRequestFullscreen();
    //     } else if (iframe.msRequestFullscreen) {
    //         iframe.msRequestFullscreen();
    //     }

    //     // Listen for fullscreen change
    //     document.addEventListener('fullscreenchange', exitHandler);
    //     document.addEventListener('webkitfullscreenchange', exitHandler);
    //     document.addEventListener('mozfullscreenchange', exitHandler);
    //     document.addEventListener('MSFullscreenChange', exitHandler);

    //     function exitHandler() {
    //         if (
    //             !document.fullscreenElement &&
    //             !document.webkitFullscreenElement &&
    //             !document.mozFullScreenElement &&
    //             !document.msFullscreenElement
    //         ) {
    //             if (player && player.pauseVideo) {
    //                 player.pauseVideo(); // or player.stopVideo();
    //             }
    //         }
    //     }
    // }
}